import i18n from "@/locales";
import { useInteractive } from "@/stores/interactive";
import { useUI } from "@/stores/ui";
import { showLoadingToast } from "vant";
import { nextTick } from "vue";
import { useRouter } from "vue-router";

export const useAddRelationPopup = () => {
  const uiStore = useUI();
  const interactiveStore = useInteractive();
  const router = useRouter();

  const addRelationship = () => {
    uiStore.popMateSelector({
      title: i18n.global.t("interactive.addRelationship"),
      mateOnly: true,
      switchMate: false,
      callback: (mateA) => {
        uiStore.showMateSelector = false;
        nextTick(() => {
          const hasPairList: number[] = [];
          interactiveStore.myRelationshipOriginList.forEach((v) => {
            if (v.sourceMateId === mateA.id) {
              hasPairList.push(v.targetMateId);
            }
          });

          uiStore.popMateSelector({
            title: i18n.global.t("interactive.addRelationshipTo", {
              name: mateA.name,
            }),
            exclude: [mateA.id, ...hasPairList],
            mateOnly: true,
            switchMate: false,
            callback: async (mateB) => {
              const loading = showLoadingToast(
                i18n.global.t(`Message.loading`)
              );
              uiStore.showMateSelector = false;
              const relationship = await interactiveStore.createRelationship(
                mateA.id,
                mateB.id
              );
              loading.close();
              router.push({
                name: "relationshipMy",
                query: {
                  id: relationship.id,
                },
              });
            },
          });
        });
      },
    });
  };
  return {
    addRelationship,
  };
};
